import { Product } from '@deizi/shared';
import { useMutation } from '@tanstack/react-query';
import { Modal } from '../../components/Overlays';
import { useToast } from '../../components/Toast';
import { api } from '../../lib/api';
import { errorMessage } from '../../lib/messages';
import { useInvalidateProducts } from '../../lib/products-api';

/** Duplicar / Arquivar / Desarquivar, with the board's toasts. */
export function useProductActions(onDuplicated?: (p: Product) => void) {
  const invalidate = useInvalidateProducts();
  const toast = useToast();
  const opts = { onError: (err: unknown) => toast(errorMessage(err)) };
  const duplicate = useMutation({
    mutationFn: (id: string) => api.post(`/products/${id}/duplicate`, Product),
    onSuccess: (p) => {
      invalidate();
      toast(`Cópia criada: ${p.name} · status Ideia`);
      onDuplicated?.(p);
    },
    ...opts,
  });
  const archive = useMutation({
    mutationFn: (id: string) => api.post(`/products/${id}/archive`, Product),
    onSuccess: (p) => {
      invalidate();
      toast(`${p.name} arquivado · veja em Arquivados`);
    },
    ...opts,
  });
  const unarchive = useMutation({
    mutationFn: (id: string) => api.post(`/products/${id}/unarchive`, Product),
    onSuccess: (p) => {
      invalidate();
      toast(
        p.status === 'active'
          ? `${p.name} voltou para Ativos`
          : `${p.name} voltou como Ideia (sem licença de venda)`,
      );
    },
    ...opts,
  });
  return { duplicate, archive, unarchive };
}

export function ArchiveDialog({
  name,
  listings,
  onConfirm,
  onClose,
}: {
  name: string;
  listings?: number;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <Modal
      title={`Arquivar ${name}?`}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="btn" onClick={onClose}>
            Cancelar
          </button>
          <button type="button" className="btn d" onClick={onConfirm}>
            Arquivar
          </button>
        </>
      }
    >
      <p className="sm">
        Sai do catálogo, do Orçamento rápido e da busca. Pedidos, fotos, arquivos e estatísticas
        continuam guardados; dá para desarquivar quando quiser.
      </p>
      {listings ? (
        <div className="alert warn">
          <div className="sm">
            {listings === 1 ? '1 anúncio continua ativo' : `${listings} anúncios continuam ativos`}{' '}
            nos canais. Pause-os por lá.
          </div>
        </div>
      ) : null}
    </Modal>
  );
}
